import React from 'react'
import PropTypes from 'prop-types'

import cn from 'classnames'

import { sortBy } from 'lodash'

import './index.scss'

const Reviews = ({ reviews = [] }) => {
  const renderAttribution = ( data = {} ) => {
    if(data.attribution_logo_path) {
      return <div className="provider-container">
        <span>Provided by</span>
        {data.attribution_url ? <a href={data.attribution_url}><img src={data.attribution_logo_path} /></a> : <img src={data.attribution_logo_path} />}
      </div>
    }

    if(data.attribution_text) {
      return <div className="provider-container">
        <span>Provided by</span>
        {data.attribution_url ? <a href={data.attribution_url}>{data.attribution_text}</a> : <span>{data.attribution_text}</span>}
      </div>
    }
    return null
  }

  const isValidDate = d => {
    return d instanceof Date && !isNaN(d);
  }

  const renderCreatedDate = createdDate => {
    try {
      const d = new Date(createdDate)
      if(isValidDate(d)){
        return <div className="date">{d.toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"}) }</div>
      }
      return null
    } catch(e) {
      //
    }

    return null
  }

  return <div className="reviews-container">
    {sortBy(reviews, ['created_date']).reverse().map( review => <div className="review-container" key={review.review_id}>
      <h4>{review.title}</h4>
      <div className="author">{review.creator}</div>
      {renderCreatedDate(review.created_date)}
      <div className="content" dangerouslySetInnerHTML = {{ __html: review.body.replace(/\\n/g, ' ') }} />
      {renderAttribution(review)}
    </div>)}
  </div>
}

export default Reviews
